import selectors from '../../rootSelectors';
import { VOCAB_FITB_FETCH_RETRY } from '../../common/api/apiRetryGetConstants';
import VocaboServiceClient from '../../common/clients/VocaboServiceClient';
import {
    playResponseAudio,
    highlightPossibleResponse,
} from '../../common/questions/questionsActions';
import { playStimulusAudio } from '../../common/stimulus/stimulusButtonActions';
import { VOCAB_GRADES_WITH_AUTOPLAY } from '../vocabConstants';
import { GENERAL_AUDIO_DELAY } from '../../constants/time';
import { fetchContent } from '../vocabActions';

export const fetchVocabFITBContent = () =>
    fetchContent(VocaboServiceClient.MEASURES.FITB, VOCAB_FITB_FETCH_RETRY);

export const autoplayScript = (questionIndex, stimulusAudio, pageType) => async (
    dispatch,
    getState,
) => {
    const state = getState();
    const grade = selectors.getGrade(state);

    if (VOCAB_GRADES_WITH_AUTOPLAY.includes(grade)) {
        const possibleResponses = selectors.getVocabFITBPossibleResponses(
            state,
            pageType,
            questionIndex,
        );

        await dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY));
        await possibleResponses.reduce(async (promise, response, index) => {
            await promise;
            dispatch(highlightPossibleResponse(index));
            await dispatch(playResponseAudio(response.audio, index, GENERAL_AUDIO_DELAY));
        }, Promise.resolve());
        dispatch(highlightPossibleResponse());
    }

    return Promise.resolve();
};
